import React, { ReactElement } from 'react';
import { BackWrapper, Container, Extra, Title } from './style';
import { BackButton } from 'newcomponents/Shared/generic/BackButton';

type Props = {
  goBack?: () => any;
  extra?: React.ReactChild;
  title: string;
  isLogin?: boolean;
};

export const NavBar = (props: Props): ReactElement => {
  return (
    <Container className={props.isLogin ? 'popup-header' : ''}>
      {props.goBack && (
        <BackWrapper className="back-wrapper">
          <BackButton onClick={props.goBack} />
        </BackWrapper>
      )}
      <Title>{props.title}</Title>
      <Extra className="extra-wrapper">{props.extra}</Extra>
    </Container>
  );
};
